module.exports = __webpack_public_path__ + "01f43047/img/share-icon.0f8a11b4.svg";